import { styled } from '@linaria/react';

export const Wrapper = styled.div`
    color: var(--text-color);

    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 6px 2px #ddd;
    height: 60px;
    padding: 0 1rem;
    width: 100%;

    @media print {
        display: none;
    }

    h1 {
        font-size: 1.5rem;
        font-weight: 200;
        margin: 0;
        position: relative;

        .sub-header {
            position: absolute;
            top: -7px;
            right: -29px;
            font-size: 1rem;
        }
    }

    @media (max-width: 768px) {
        padding: 0 0.5rem;
    }
`;

export const LeftContentWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

export const MiddleContentWrapper = styled.div`
   position: absolute;
    left: calc(50% - 175px);
    width: 350px;
    display: flex;
    gap: 20px;

    @media (max-width: 768px) and (pointer: coarse) {
        display: none;
    }
`;



export const RightContentWrapper = styled.div`
    font-size: 0.8rem;
    font-weight: 400;
    display: flex;
    flex: 1 1 25%;
    max-width: 25%;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;

    @media (max-width: 768px) and (pointer: coarse) {
        display: none;
    }
`;

export const LogoWrapper = styled.div`
    display: flex;
    align-items: center;

    a {
        text-decoration: none;
        color: inherit;
    }
`;

export const IconWrapper = styled.div`
    border-left: 1px solid var(--border-color);
    display: flex;
    height: 40px;
    padding: 0 10px;
    align-items: center;
    gap: 5px;

    &.no-border {
        border-left: 0;
    }

    &:first-child {
        border-left: 0;
    }
`;

export const SearchWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-left: 2rem;
    flex: 1;
    max-width: 500px;
    gap: 0.5rem;
    position: relative;
`;

export const SearchForm = styled.form`
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 0.25rem;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 0.5rem 5rem 0.5rem 1rem;
    border: 1px solid var(--border-color);
    border-radius: 20px;
    font-size: 0.875rem;
    background: #f8f9fa;

    &:focus {
        outline: none;
        border-color: var(--primary-color);
        box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
    }

    &::placeholder {
        color: #6c757d;
    }
`;

export const SearchButton = styled.button`
    position: absolute;
    right: 38px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #6c757d;

    &:hover {
        color: var(--primary-color);
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const SearchSettingsButton = styled.button`
    position: absolute;
    right: 8px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #6c757d;
    transition: color 0.2s ease;

    &:hover,
    &.active {
        color: var(--primary-color);
    }

    svg {
        width: 18px;
        height: 18px;
    }
`;

export const SearchSettingsPanel = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 0.5rem;
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 1rem;
    z-index: 1000;
    display: flex;
    gap: 1.5rem;
`;

export const SettingsSection = styled.div`
    flex: 1;
    min-width: 0;
`;

export const SettingsSectionTitle = styled.div`
    font-weight: 600;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    color: var(--text-color);
`;

export const SettingsCheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    label {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.875rem;
        cursor: pointer;
        color: var(--text-color);

        &:hover {
            color: var(--primary-color);
        }

        input[type='checkbox'] {
            cursor: pointer;
        }
    }
`;

export const VersionWrapper = styled.div`
    font-weight: 400;
    font-size: 0.7rem;
    color: #6c757d;
    margin-top: 1.5rem;
`;

export const DisclaimerWrapper = styled.div`
    position: relative;
    margin-left: 3rem;
    align-self: flex-end;

    @media (max-width: 768px) and (pointer: coarse) {
        display: none;
    }
`;

export const DisclaimerLink = styled.span`
    font-size: 0.75rem;
    font-weight: 600;
    color: #0066cc;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
        color: #004c99;
    }
`;

export const DisclaimerTooltip = styled.div<{ $visible?: boolean }>`
    display: ${({ $visible }) => ($visible ? 'block' : 'none')};
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    width: 520px;
    background: #f0f4fa;
    border: 1px solid #c8d6e5;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    padding: 1.5rem 2rem;
    z-index: 2000;
    cursor: default;

    h3 {
        font-size: 1rem;
        font-weight: 700;
        margin: 0 0 0.75rem 0;
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }

    h3 img {
        height: 48px;
    }

    p {
        font-size: 0.8rem;
        line-height: 1.5;
        color: #333;
        margin: 0 0 0.5rem 0;
    }

    p:last-child {
        margin-bottom: 0;
    }
`;

export const MobileMenuButton = styled.button`
    display: none;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    color: var(--text-color);
    font-size: 1.25rem;
    line-height: 1;

    @media (max-width: 768px) and (pointer: coarse) {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const MobileMenuOverlay = styled.div<{ $open: boolean }>`
    display: none;

    @media (max-width: 768px) and (pointer: coarse) {
        display: ${props => props.$open ? 'block' : 'none'};
        position: fixed;
        top: 60px;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 999;
    }
`;

export const MobileMenuPanel = styled.div<{ $open: boolean }>`
    display: none;

    @media (max-width: 768px) and (pointer: coarse) {
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 60px;
        right: 0;
        width: 260px;
        bottom: 0;
        background: white;
        box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 0.5rem 0;
        transform: ${props => props.$open ? 'translateX(0)' : 'translateX(100%)'};
        transition: transform 0.25s ease;
    }
`;

export const MobileMenuItem = styled.button<{ $active?: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    padding: 0.85rem 1.25rem;
    background: ${props => props.$active ? '#f0f4ff' : 'none'};
    border: none;
    border-left: 3px solid ${props => props.$active ? '#0066cc' : 'transparent'};
    cursor: pointer;
    font-size: 0.9rem;
    color: ${props => props.$active ? '#0066cc' : '#333'};
    font-weight: ${props => props.$active ? '600' : '400'};
    text-align: left;
    transition: all 0.15s ease;

    &:hover {
        background: #f8f9fa;
        color: #0066cc;
    }

    svg {
        width: 18px;
        text-align: center;
        flex-shrink: 0;
    }
`;

export const MobileMenuDivider = styled.hr`
    border: none;
    border-top: 1px solid #e9ecef;
    margin: 0.25rem 0;
`;
